import JsonEditor from './JsonEditor'
import JsonView from './JsonView'
import ArrayView from './ArrayView'

const install = (Vue) => {
  if (install.installed) return

  Vue.component('JsonEditor', JsonEditor)
  Vue.component('json-view', JsonView)
  Vue.component('array-view', ArrayView)

  Array.prototype.rmIndex = function (index) {
    this.splice(index, 1)
    return this
  }
}

export default install

export const components = {
  JsonEditor,
  VERSION: '0.1.0'
}
